import React from 'react';
import L from 'leaflet';
import { Marker } from 'react-leaflet-universal';
import * as stagePoints from '../../../data/stage-points.json';
import './MapMarkers.css';

const createStagePoint = stageNo => {
  const iconSize = 60;
  return new L.Icon({
    iconUrl: require(`../../../assets/images/stages/stage${stageNo}.svg`),
    iconRetinaUrl: require(`../../../assets/images/stages/stage${stageNo}.svg`),
    iconSize: [iconSize, iconSize],
  })
}

const createStagePoints = zoom => {
  let parent = [];
  if (zoom > 4) {
    stagePoints.default.data.forEach((item, idx) => {
      parent.push(<Marker key={`sp_${idx}`} position={item} icon={createStagePoint(idx + 1, zoom)}> </Marker>);
    });
  }
  return parent;
}

const MapMarkers = props => {
  return (<span>
    {createStagePoints(props.zoom)}
  </span>)
}

export { MapMarkers as default }